import { render, staticRenderFns } from "./duplicateCandidate.vue?vue&type=template&id=4bcc83f4&scoped=true"
import script from "./duplicateCandidate.vue?vue&type=script&lang=js"
export * from "./duplicateCandidate.vue?vue&type=script&lang=js"
import style0 from "./duplicateCandidate.vue?vue&type=style&index=0&id=4bcc83f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc83f4",
  null
  
)

export default component.exports